
export function Dialog({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-0">
        <div className="flex flex-col">
          <div className="flex justify-between items-center p-4 border-b border-gray-200">
            <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
            <button
              className="text-indigo-500 hover:text-white rounded-full border border-white hover:bg-indigo-600 cursor-pointer h-8 w-8"
              onClick={onClose}
              aria-label="Close"
            >
              <i className="fas fa-times w-5 ht-5 hb-4"></i>
            </button>
          </div>
          <div className="p-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
